import { useMemo } from "react";
 
 export const UseSidebarNavigation = () => {
	const sideBarUser = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      // {
      //   link: "/patients",
      //   label: "output_patient",
      //   icon: "fa fa-layer-group me-2",
      //   children: null,
      // },
      // {
      //   link: "/lab/lab-record",
      //   label: "lab_record",
      //   icon: "fa fa-layer-group me-2",
      //   children: null,
      // },
      // {
      //   link: "/admit-patient",
      //   label: "ipd",
      //   icon: "fa fa-layer-group me-2",
      //   children: null,
      // },
      // {
      //   link: "/cashier",
      //   label: "cashier",
      //   icon: "fa fa-layer-group me-2",
      //   children: [
      //     {
      //       link: "/cashier/all-sales",
      //       label: "all_sales",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/requisitions",
      //       label: "expenditors",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/cashdrop",
      //       label: "cash_drop",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/cash-journal",
      //       label: "cash_journal",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/other-revenue",
      //       label: "other_revenue",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/patients-checkout",
      //       label: "patients_checkout",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/account-summary",
      //       label: "staff_account_summary",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/cashier/cashdesk-journal",
      //       label: "cashdesk_journal",
      //       icon: "fa fa-layer-group me-3 ",
      //       children: null,
      //     },
      //   ],
      // },
      // {
      //   link: "/accounting",
      //   label: "accounting",
      //   icon: "fa fa-layer-group me-2",
      //   children: [
      //     {
      //       link: "/accounting/banking",
      //       label: "banking_account",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/accounting/budgeting",
      //       label: "budgeting",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/accounting/requisitions",
      //       label: "requisitions",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/accounting/report-incomes",
      //       label: "incomes_report",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/accounting/trial-balance",
      //       label: "trial_balance_leger",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/settings/accounting",
      //       label: "class_accounts",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/accounting/journal",
      //       label: "journal",
      //       icon: "",
      //       children: null,
      //     },
      //   ],
      // },
      // {
      //   link: "/pharmacy",
      //   label: "pharmacy",
      //   icon: "fa fa-layer-group me-2",
      //   children: [
      //     {
      //       link: "/pharmacy/invoices-list",
      //       label: "invoices",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/pharmacy/occupied_wards",
      //       label: "occupied_wards",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/pharmacy/transfert-order",
      //       label: "stock_recieved",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/pharmacy/stock-reports",
      //       label: "stock_reports",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/pharmacy/inventory",
      //       label: "inventories_count",
      //       icon: "",
      //       children: null,
      //     },
      //   ],
      // },
      // {
      //   link: "/warehouse",
      //   label: "warehouse",
      //   icon: "fa fa-layer-group me-2",
      //   children: [
      //     {
      //       link: "/warehouse/record-supplier",
      //       label: "record_suppliers",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/warehouse/purchase-supplier",
      //       label: "record_purchase",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/warehouse/item-record",
      //       label: "items_record",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/warehouse/transfert-order",
      //       label: "stock_transfert",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/warehouse/stock-reports",
      //       label: "stock_reports",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/warehouse/inventory",
      //       label: "inventories_count",
      //       icon: "",
      //       children: null,
      //     },
      //   ],
      // },
      // {
      //   link: "/lab",
      //   label: "Lab",
      //   icon: "fa fa-layer-group me-2",
      //   children: [
      //     {
      //       link: "/lab/lab-record",
      //       label: "lab_record",
      //       icon: "fa fa-layer-group me-2",
      //       children: null,
      //     },
      //     {
      //       link: "/settings/samples",
      //       label: "Lab samples",
      //       icon: "",
      //       children: null,
      //     },
      //     {
      //       link: "/settings/remarks",
      //       label: "Lab remarks",
      //       icon: "",
      //       children: null,
      //     },
      //   ],
      // },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
      {
        link: "/payroll",
        label: "Payroll",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/payroll/setting",
            label: "setting_zone",
            children: null,
          },
          {
            link: "/payroll/staff-management",
            label: "staff_management",
            children: null,
          },
          // {
          //   link: "/payroll/deduction-master",
          //   label: "deduction_master",
          //   children: null,
          // },
          {
            link: "/payroll/loans",
            label: "loans_and_advances",
            children: null,
          },
          {
            link: "/payroll/paymaster",
            label: "Pay_master",
            children: null,
          },
          {
            link: "/reports",
            label: "Reports",
            icon: "fa fa-layer-group me-2",
            children: [
              {
                link: "/reports/cnps",
                label: "CNPS Report",
                icon: "me-2",
                children: null,
              },
              // { link: "/reports/tax", label: "Tax Report", icon: "fa fa-layer-group me-2", children: null},
            ],
          },
        ],
      },

      // {
      //   link: "/backup",
      //   label: "Backup",
      //   icon: "fa fa-layer-group me-2",
      //   children: null,
      // },
      {
        link: "/settings",
        label: "settings",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarOPD = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/patients",
        label: "output_patient",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarIPD = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/admit-patient",
        label: "ipd",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarCashier = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/cashier",
        label: "cashier",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/cashier/all-sales",
            label: "all_sales",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/requisitions",
            label: "expenditors",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/cashdrop",
            label: "cash_drop",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/cash-journal",
            label: "cash_journal",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/other-revenue",
            label: "other_revenue",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/patients-checkout",
            label: "patients_checkout",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/account-summary",
            label: "staff_account_summary",
            icon: "",
            children: null,
          },
          {
            link: "/cashier/cashdesk-journal",
            label: "cashdesk_journal",
            icon: "",
            children: null,
          },
        ],
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarPharmacisit = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/pharmacy",
        label: "pharmacy",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/pharmacy/invoices-list",
            label: "invoices",
            icon: "",
            children: null,
          },
          {
            link: "/pharmacy/occupied_wards",
            label: "occupied_wards",
            icon: "",
            children: null,
          },
          {
            link: "/pharmacy/transfert-order",
            label: "stock_recieved",
            icon: "",
            children: null,
          },
          // { link: "/pharmacy/stock-transfert", label: "stock_transfers", icon: "", children: null},
          {
            link: "/pharmacy/stock-reports",
            label: "stock_reports",
            icon: "",
            children: null,
          },
          //  {
          //    link: "/pharmacy/inventory",
          //    label: "inventories_count",
          //    icon: "",
          //    children: null,
          //  },
        ],
      },
      {
        link: "/reports",
        label: "Reports",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/reports/mySales",
            label: "My Sales",
            icon: "",
            children: null,
          },
          {
            link: "/reports/postedSales",
            label: "Posted Sales",
            icon: "",
            children: null,
          },
        ],
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarUserLab = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/lab/lab-record",
        label: "lab_record",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
      {
        link: "/settings",
        label: "settings",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/settings/samples",
            label: "samples",
            icon: "",
            children: null,
          },
          {
            link: "/settings/remarks",
            label: "remarks",
            icon: "",
            children: null,
          },
        ],
      },
    ],
    [],
  );

  const sideBarAccountant = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/accounting",
        label: "accounting",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/accounting/banking",
            label: "banking_account",
            icon: "",
            children: null,
          },
          {
            link: "/accounting/budgeting",
            label: "budgeting",
            icon: "",
            children: null,
          },
          {
            link: "/accounting/requisitions",
            label: "requisitions",
            icon: "",
            children: null,
          },
          {
            link: "/accounting/report-incomes",
            label: "incomes_report",
            icon: "",
            children: null,
          },
        ],
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarDoctor = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/doctor/doctor-panel-see-patient",
        label: "doctor-panel",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
      {
        link: "/profile",
        label: "my_profile",
        icon: "fa fa-layer-group me-2",
        children: null,
      },
    ],
    [],
  );

  const sideBarStockController = useMemo(
    () => [
      {
        link: "/dashboard",
        label: "dashboard",
        icon: "fa fa-house me-2",
        children: null,
      },
      {
        link: "/warehouse",
        label: "warehouse",
        icon: "fa fa-layer-group me-2",
        children: [
          {
            link: "/warehouse/record-supplier",
            label: "record_suppliers",
            icon: "",
            children: null,
          },
          {
            link: "/warehouse/purchase-supplier",
            label: "record_purchase",
            icon: "",
            children: null,
          },
          {
            link: "/warehouse/item-record",
            label: "items_record",
            icon: "",
            children: null,
          },
          {
            link: "/warehouse/transfert-order",
            label: "stock_transfert",
            icon: "",
            children: null,
          },
          {
            link: "/warehouse/stock-reports",
            label: "stock_reports",
            icon: "",
            children: null,
          },
          {
            link: "/warehouse/inventory",
            label: "inventories_count",
            icon: "",
            children: null,
          },
        ],
      },
    ],
    [],
  );
   return {
     sideBarUser,
     sideBarUserLab,
     sideBarAccountant,
     sideBarDoctor,
     sideBarStockController,
     sideBarPharmacisit,
     sideBarCashier,
     sideBarIPD,
     sideBarOPD,
   };
 }
 